module.exports = __webpack_public_path__ + "img/vertical_1_1_5010.3c09906b.png";